/**
 * Balance ranges belong to the saved goal, not to an unsaved selection.
 * Let bod-users reset overrides and return the new ranges after saving.
 */
export function initGoalBalance(form) {
    const goal = form.querySelector('#goalCode');
    const savedGoal = goal && goal.value;
    const balance = form.querySelector('.macro-balance');
    const modifier = form.querySelector('#calorieModifier');
    const originalDisplay = balance && balance.style.display;
    const originalDisabled = modifier && modifier.disabled;
    let previousModifier;
    let pending = false;
    let note;

    if (balance || modifier) {
        note = document.createElement('p');
        note.className = 'form-text text-muted goal-balance-note';
        note.style.flexBasis = '100%';
        note.setAttribute('role', 'status');
        note.textContent = 'Сохраните новую цель — затем можно настроить баланс БЖУ.';
        note.hidden = true;
        const anchor = balance || modifier.closest('.floating-label-1') || modifier;
        anchor.parentNode.insertBefore(note, anchor.nextSibling);
    }

    function sync() {
        const changed = !!goal && goal.value !== savedGoal;
        if (changed === pending) return;
        pending = changed;
        if (balance) balance.style.display = changed ? 'none' : originalDisplay;
        if (note) note.hidden = !changed;
        if (modifier) {
            if (changed) {
                previousModifier = modifier.value;
                modifier.value = '';
                modifier.disabled = true;
                // Keep the blank placeholder: visible placeholder text overlaps
                // the floating label on an empty input. The note explains why
                // the field is temporarily disabled.
            } else {
                modifier.value = previousModifier;
                modifier.disabled = originalDisabled;
            }
        }
    }

    if (goal) {
        goal.addEventListener('change', sync);
        // multiselect uses the page's jQuery, not the webpack copy.
        const pageJQuery = document.defaultView['jQuery'];
        if (pageJQuery) pageJQuery(goal).on('change', sync);
    }

    return {
        prepare(params) {
            // Check the actual payload as well: a plugin or script can change
            // the select value without dispatching an event.
            const changed = !!goal && params.goalCode !== undefined
                && params.goalCode !== savedGoal;
            if (changed) delete params.statsOverrides;
            return changed;
        },
    };
}
